import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectMessageButtonAvailable } from 'shared/selectors/messageButton';

import { getFlatTourSchedule } from '../../../browser/services/flatTourBooking';
import { DefaultContactsLayout } from '../../components/NewbuildingContactsLayout';
import { canMakeFlatViewOrder, getIsCallbackAvailable } from '../../selectors';
import { selectNewbuildingBrokerOfferBookingEnabled } from '../../selectors/featureToggle';
import { selectIsBookedFromDeveloper } from '../../selectors/newbuildingBookedFromDeveloper';
import { TCallbackOpener } from '../../types/callbackPopup';
import { CallBackButtonContainer } from '../CallBackButton';
import { FlatViewButtonContainer } from '../FlatViewButtonContainer';
import { NewbuildingBookedFromDeveloperButtonContainer } from '../NewbuildingBookedFromDeveloperButtonContainer';
import { NewbuildingBrokerOfferBookingButtonContainer } from '../NewbuildingBrokerOfferBookingButtonContainer';

export interface INewbuildingContactsContainerProps {
  callbackPlaceType: TCallbackOpener;
  contactsButton: React.ReactNode;
  messageButton?: React.ReactNode;
  messageButtonInSeparateRow?: boolean;
}

export const NewbuildingContactsContainer = ({
  contactsButton,
  messageButton,
  messageButtonInSeparateRow,
  callbackPlaceType,
}: INewbuildingContactsContainerProps) => {
  const dispatch = useDispatch();

  const isCallbackButtonAvailable = useSelector(getIsCallbackAvailable);
  const isOfferBookingEnabled = useSelector(selectNewbuildingBrokerOfferBookingEnabled);
  const isFlatViewButtonVisible = useSelector(canMakeFlatViewOrder);
  const isBookedFromDeveloper = useSelector(selectIsBookedFromDeveloper);
  const isMessageButtonAvailable = useSelector(selectMessageButtonAvailable);
  const isFloatingBlock = callbackPlaceType === 'floating_block';

  const renderCallbackButton = (extProps?: { collapsed?: boolean }) => {
    // TODO: В CD-235461 после запуска проекта бронирования удалить отсюда кнопку вообще.
    /* istanbul ignore else */
    if (isOfferBookingEnabled || !isCallbackButtonAvailable || (isMessageButtonAvailable && isFloatingBlock)) {
      return null;
    }

    /* istanbul ignore next */
    return <CallBackButtonContainer placeType={callbackPlaceType} {...extProps} />;
  };

  const renderFlatViewButton = (extProps?: { collapsed?: boolean }) => {
    // TODO: В CD-235461 после запуска проекта бронирования удалить отсюда кнопку вообще.
    /* istanbul ignore else */
    if (isOfferBookingEnabled) {
      return null;
    }

    /* istanbul ignore next */
    return isFlatViewButtonVisible ? <FlatViewButtonContainer {...extProps} /> : null;
  };

  React.useEffect(() => {
    dispatch(getFlatTourSchedule());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isBookedFromDeveloper) {
    return (
      <NewbuildingBookedFromDeveloperButtonContainer
        buttons={
          <DefaultContactsLayout
            contactsButton={contactsButton}
            messageButton={messageButton}
            wrap={!isOfferBookingEnabled}
            messageButtonInSeparateRow={messageButtonInSeparateRow}
          />
        }
      />
    );
  }

  return (
    <DefaultContactsLayout
      contactsButton={contactsButton}
      messageButton={messageButton}
      callbackButton={renderCallbackButton()}
      flatViewButton={renderFlatViewButton()}
      offerBookingButton={<NewbuildingBrokerOfferBookingButtonContainer />}
      wrap={!isOfferBookingEnabled}
      messageButtonInSeparateRow={messageButtonInSeparateRow}
    />
  );
};
